import { DocumentIconV2, FileIconV2 } from 'app/assets/icons';
import React from 'react';
import styled, { useTheme } from 'styled-components';
import { CustomToolTip } from '../CustomToolTip';
import Dropdown from '../CustomDropDown';
import { LookupDto } from 'api/openapi';
import { dropdownType } from 'app/pages/FacilityPage';
import { formatAmount } from 'utils/common';

type Props = {
  title: string;
  value: number | undefined;
  type: 'active' | 'expired' | 'closed' | 'upcomingRenewals' | 'sublimit';
  dropdownData?: dropdownType[];
  dropdownValue?: dropdownType | undefined;
  isDropdownDisabled?: boolean;
  onDropdownChange?: (e: LookupDto) => void;
  hideDropdown?: boolean;
  isLoadingDropdown?: boolean;
  loaderHeight?: number;
};
export const SummaryTilesV2 = ({
  title,
  value,
  type,
  dropdownData,
  dropdownValue,
  isDropdownDisabled,
  onDropdownChange,
  hideDropdown,
  isLoadingDropdown,
  loaderHeight,
}: Props) => {
  const theme = useTheme();
  return (
    <Wrapper className={`${type} summary-tile-component`}>
      <div className="svg-wrapper">
        {type === 'upcomingRenewals' || type === 'sublimit' ? (
          <div className={'responsive-for-mobile'}>
            <DocumentIconV2
              color={
                type === 'sublimit'
                  ? theme.sublimitIconClr
                  : theme.upcomingRenewalsIconClr
              }
            />
            <div className="tiles-title-mobile">{title}</div>
          </div>
        ) : (
          <div className={'responsive-for-mobile'}>
            <div className="icon-wrapper">
              <FileIconV2
                color={
                  type === 'active'
                    ? theme.activeIconClr
                    : type === 'expired'
                    ? theme.expiredIconClr
                    : type === 'closed'
                    ? theme.closedIconClr
                    : undefined
                }
              />
            </div>
            <div className="tiles-title-mobile">{title}</div>
          </div>
        )}
      </div>
      <div className="title-value-wrapper">
        <div className="tiles-title">{title}</div>
        <CustomToolTip>
          <div
            className="tiles-value"
            title={`AED ${value?.toLocaleString() ?? 0}`}
          >{`AED ${value ? formatAmount(value) : 0}`}</div>
        </CustomToolTip>
      </div>

      {!hideDropdown ? (
        <StyledDropdown
          options={dropdownData!}
          onChange={e => {
            onDropdownChange?.(e);
          }}
          value={dropdownValue}
          isSearchNotRequired
          disabled={isDropdownDisabled}
          isLoader={isLoadingDropdown}
          loaderHeight={loaderHeight ? loaderHeight : 23}
        />
      ) : (
        <div style={{ height: '23px' }}></div>
      )}
    </Wrapper>
  );
};

const StyledDropdown = styled(Dropdown)`
  width: 113px;
  button {
    min-height: 23px;
    font-size: 10px;
    padding: 0px 9px 0px 9px;
  }
  .dropdown-menu {
    top: 28px;
    li {
      font-size: 10px;
      font-weight: 400;
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 138px;
  height: 156px;
  border: 1px solid ${p => p.theme.summaryCardBrdrClrV2};
  font-family: 'Open Sans';
  font-weight: 600;
  background: ${p => p.theme.white};
  border-radius: 15px;
  box-shadow: -0.5px 3px 4px 0px ${p => p.theme.summaryCardBoxShadowV2};
  padding: 16px 6px;
  justify-content: space-between;

  @media (min-width: 100px) and (max-width: 768px) {
    padding: 6px 6px;
  }

  .svg-wrapper {
    display: flex;
    align-items: center;
    height: 45px;
    width: 45px;
    justify-content: center;
    border-radius: 12px;

    @media (min-width: 100px) and (max-width: 768px) {
      .responsive-for-mobile {
        display: flex;
        align-items: center;
        .icon-wrapper {
          width: 45px;
          display: flex;
          justify-content: center;
        }
      }
    }
  }

  .tiles-title {
    display: flex;
    align-items: center;
    color: ${p => p.theme.tilesTitle};
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    height: 36px;
  }
  .tiles-value {
    color: ${p => p.theme.tilesValueClr};
    font-size: 15px;
    font-weight: 600;
    width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .title-value-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  &.active {
    .tiles-value {
      color: ${p => p.theme.tilesActiveClr};
    }
  }
  &.expired {
    .tiles-value {
      color: ${p => p.theme.tilesExpiredClr};
    }
  }
  &.inactive {
    .tiles-value {
      color: ${p => p.theme.tilesInactiveClr};
    }
  }
  &:hover {
    .tiles-value {
      font-weight: 700;
    }
    .svg-wrapper {
      background: ${p => p.theme.summaryTilesSvgBg};
    }
  }
  @media (min-width: 769px) and (max-width: 1082px) {
    width: 124px;
    height: 138px;
    padding-top: 8px;
    .tiles-title {
      font-size: 10px;
      height: 26px;
    }
    button {
      height: 24px;
    }
  }
  @media (min-width: 769px) {
    .tiles-title-mobile {
      display: none;
    }
  }
  @media (max-width: 768px) {
    .tiles-title {
      display: none;
    }
  }
`;
